__turbopack_context__.v({
  "className": "caveat_63e83076-module__ALuW9G__className",
});
